import { ReuploadAction } from "components/Reusable/FilesActionGroup/ReuploadAction";
import { useContent } from "contexts/contentContext/contentContext";
import { useMail } from "contexts/mailContext/mailContext";
import bytesToDisplayHelper from "utils/bytesToDisplayHelper";
import useUploadComplete from "../hooks/useUploadComplete";
import { memo } from "react";

const UploadedFilesInfo = memo(() => {
  const { getTextByKey } = useContent();
  const { getMailMetaData, getMailId } = useMail();
  const { isSizeValidation } = useUploadComplete();

  const size = bytesToDisplayHelper(getMailMetaData().TotalSize);

  return (
    <div className="upload-complete-sidebar-body-row uploaded-files-row">
      <div className="info">
        <div className="info-title">
          {getTextByKey("upload-complete-number-of-files")}:
        </div>
        <div className="info-value">
          {getMailMetaData().filesCount} ({size.size + size.type})
          {isSizeValidation
            ? ` / ${getMailMetaData().expectedFilesCount}`
            : null}
        </div>
      </div>

      <ReuploadAction mailId={getMailId()} />
    </div>
  );
});

UploadedFilesInfo.displayName = "UploadedFilesInfo";

export default UploadedFilesInfo;
